import { log } from '@/utils/console';

interface PostMessageParams {
  name: string;
  action: string;
  id: string;
  params?: any;
  type?: string
  preLoadCompleteMode?: string
}


/**
  * @description 放置
  */
export const postDragDownMessageToReact = (dragId: string, materialLibraryId?: any) => {
  log('在浏览器外放置', {
    id: dragId,
    materialLibraryId
  });
  postMessageToParent("MaterialDrag", "dragModelFromView", {
    id: dragId,
    materialLibraryId
  })
}
/**
* @description 取消拖拽事件
*/
export const postDragCancelMessageToReact = () => {
  log('取消拖拽事件');
  postMessageToParent("MaterialCanDrag", "canDragModel")
}

/**
* @description 移动
*/
export const postDragMoveMessageToReact = (params: any) => {
  postMessageToParent("modelMove", "modelMove", params, '1', true)
}

/**
* @description 失去焦点事件
*/
export const postOnBlurMessageToReact = () => {
  log('页面失去焦点事件');
  postMessageToParent("ModelAISearch", "onBlur")
}


/**
* @description 设置宽度(固定加减)
*/
export const postSetWidthMessageToReact = (isAdd: boolean) => {
  if (!isInIframe) return
  postMessageToParent("ModelAISet", "setWidth", {
    add: isAdd
  })
}
/**
* @description 设置宽度(指定值)setWidthByNumber
* @param width 宽度
* @param mode 模式 可能的值有：'home'、'aluminum'、'hard' | 'quanwu'。
*/
export const postSetWidthByNumberMessageToReact = (width: number, minWidth: number, mode: 'home' | 'aluminum' | 'hard' | 'quanwu') => {
  if (!isInIframe) return
  postMessageToParent("ModelAISet", "setWidthByNumber", {
    width,
    minWidth,
    mode
  })
}
/**
* @description setDetailId
*/
export const postDetailIdMessageToReact = (detailId: string) => {
  postMessageToParent("ModelAISet", "getDetailId", {
    detailId
  })
}
/**
* @description 折叠
*/
export const postCollapseMessageToReact = (state: boolean) => {
  postMessageToParent("ModelAISetCollapse", "setCollapse", {
    state
  })
}
/**
* @description postWindowCloseToReact
*/
export const postWindowCloseToReact = () => {
  postMessageToParent("ModelAIClose", "close")
}
interface Data {
  data: any
  type: string
  tab?: string
  totals: number
  current: number
  action: string
  lastSortValues: any
}
/**
* @description postDataToReact
*/
export const postDataToReact = (params: Data) => {
  if (!isInIframe) return
  postMessageToParent("ModelAISetData", params.action, params)
}
/**
* @description postScrollTopToReact
*/
export const postScrollTopToReact = ({ scrollTop, detailScrollTop, action }: { scrollTop?: number, detailScrollTop?: number, action: string }) => {
  if (!isInIframe) return
  postMessageToParent("ModelAISetScrollTop", action, {
    scrollTop,
    detailScrollTop
  })
}
/**
* @description postCurrentReact
*/
export const postCurrentReact = (current: number) => {
  if (!isInIframe) return
  postMessageToParent("ModelAISetScrollCurrent", 'current', current)
}
/**
* @description postCurrentReact
*/
export const postDetailCurrentReact = (current: number) => {
  if (!isInIframe) return
  postMessageToParent("ModelAISetScrollCurrent", 'detailCurrent', current)
}
/**
* @description 设置宽度
*/
export const postKeyWordMessageToReact = (keyWord: string | undefined | null) => {
  if (!isInIframe) return
  postMessageToParent("ModelAISetKeyWord", 'setKeyWord', {
    keyWord: keyWord
  })
}
/**
* @description 释放鼠标焦点
*/
export const postReleaseFocusMessageToReact = () => {
  postMessageToParent("", 'releaseFocus')
}

const postMessageToParent = (name: string, action: string, params?: any, id = '1', isOutSide = false): void => {
  const parent = opener();
  const messageData: { origin: string, data: PostMessageParams, params?: any } = {
    origin: "uiapi.materialUiplugin",
    data: {
      name,
      action,
      id,
      type: 'home',
      preLoadCompleteMode: 'home'
    }
  };

  if (isOutSide && params) {
    messageData.params = params
  } else {
    messageData.data.params = params;
  }

  parent?.postMessage(messageData, '*');
};
/**
* @description 判断当前页面是否在 iframe 内
*/
const checkIsInIframe = () => {
  try {
    // 只是在3d模型的时候才会有这个参数
    return window.self !== window.top
  } catch (e) {
    return true;
  }
}

/**
* @description 缓存当前页面是否在 iframe 内的判断结果
*/
export const isInIframe = checkIsInIframe();

/**
* @description 返回postMessage
*/
export const opener = (): Window | null => {
  if (isInIframe) {
    return (window as any)?.parent
  } else {
    return (window as any)?.opener
  }
}

/**
* @description 设置宽度
*/
export const postQuickOpen = () => {
  if (!isInIframe) return
  postMessageToParent("ModelAISet", "quickOpen")
}
/**
* @description postWindowCloseToReact
*/
export const postCannotDragToReact = (params: any) => {
  postMessageToParent("cannotDragFormMaterial", "cannotDrag", params)
}
/**
* @description 传递快捷键到react里面
*/
export const postKeyDownToReact = (params: string) => {
  if (!isInIframe) return
  postMessageToParent("KeyDownMessage", 'keyDown', params)
}

/**
* @description 传递信息是否扩展iframe宽度
*/
export const postIframePlaceholderToExpand = (expand: boolean) => {
  if (!isInIframe) return
  postMessageToParent('', 'expandIframe', { expand })
};
/**
* @description 显示或关闭以图搜模型帮助引导
*/
export const postSearchImageHelpTipMessageToReact = (visible: boolean) => {
  if (!isInIframe) return
  postMessageToParent('', 'setSearchImageHelpTip', {
    visible,
    channelCode: 'HelpTip-03',
    placement: 'bottomRight'
  })
};
/**
* @description 传递信息是否关闭全局loading动画
*/
export const postIframeLoadingStatus = (loading: boolean) => {
  postMessageToParent('', 'setLoading', { loading })
}
/**
* @description 传递信息设置setDirectoryMode
*/
export const postSetDirectoryMode = (directoryMode: '0' | '1' | '2') => {
  postMessageToParent('', 'setDirectoryMode', { directoryMode })
}

/**
* @description 传递信息是否预加载完成
*/
export const postPreloadComplete = () => {
  postMessageToParent('', 'preLoadComplete')
}
